/**
 * Finsemble entry point for services and the service manager.
 */
import { RouterClient, RouterController } from "../routerClient";
import { getRouterConfig, getSystemStartupData, getManifestFromStartupData } from "./RouterConfig";
import { System } from "../../common/system";
import { Startup } from "./Startup";
import { Globals } from "../../common/Globals";
import { FinsembleDesktopAgent } from "../Interop/FinsembleDesktopAgent";
import { DesktopAgent } from "@finos/fdc3";
import uuidv4 from "uuid-random";

export class FSBLService {
	/**
	 * Starts Finsemble for internal service and service manager windows
	 */
	async startApp() {
		const systemStartupData = await getSystemStartupData();
		const finWindow = System.Window.getCurrent();
		const appName = finWindow.name ?? document?.location?.href ?? "Unknown App";
		const windowName = finWindow.name ?? document?.location?.href ?? `Unknown window-${uuidv4()}`;
		const webContentsName = finWindow.webContentsName ?? windowName;

		/**
		 * The system manifest is provided in the startup data. At early stages, this is available
		 * at the root level. In later stages, a more complete manifest is available in customData.
		 */
		const systemManifest = getManifestFromStartupData(systemStartupData) ?? {};
		const routerConfig = getRouterConfig({
			windowName,
			systemManifest,
			isFSBLService: true,
		});
		await RouterController.start(routerConfig);
		const startup = Startup.getInstance();
		startup.setStartupData({
			windowName,
			webContentsName,
			authenticationToken: {
				signatureString: "",
				signatureStringType: "unauthenticated",
				meta: {
					name: appName,
					appId: appName,
				},
			},
		});

		// Made fdc3 available to services. This is temporary until services become invisible, singleton apps.
		Globals.fdc3 = <DesktopAgent>new FinsembleDesktopAgent({
			routerClient: RouterClient,
			startup,
		});

		startup.setReady();
		// search for Logger.start() and client initialize calls in services and move them here
	}

	async stopApp() {
		RouterController.stop();
	}
}
